import { render, staticRenderFns } from "./MonetaIframe.vue?vue&type=template&id=649ef6ea&scoped=true&"
import script from "./MonetaIframe.vue?vue&type=script&lang=js&"
export * from "./MonetaIframe.vue?vue&type=script&lang=js&"
import style0 from "./MonetaIframe.vue?vue&type=style&index=0&id=649ef6ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649ef6ea",
  null
  
)

export default component.exports